import React, { useEffect, useState } from "react";
import axios from "../api/baseurl";
import { useNavigate } from "react-router-dom";
import "./Spinner.css";
import "./Loader.css";
import { toast } from "react-toastify";
import { FiInfo } from "react-icons/fi";
import TestForPackage from "./testsByPackagePopup";
import { Pagination } from "react-bootstrap";
import PemeAppointmentReschedule from "./pemeAppointmentReschedule";
import PemeAppointmentCancel from "./pemeAppointmentCancellation";
import UploadPemeReport from "./uploadPemeAppointmentReport";
import { FaEdit, FaDownload } from "react-icons/fa";
import "./hm-theme.css";

function ViewPemeAppointmentsForLab({ labId }) {
  const [appointmentDetails, setAppointmentDetails] = useState([]);
  const [loader, setLoader] = useState(false);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
  const [isCancelPopupOpen, setIsCancelPopupOpen] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [isReschedulePopupOpen, setIsReschedulePopupOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCompany, setSelectedCompany] = useState("all");
  const [companies, setCompanies] = useState([]);
  const userRole = JSON.parse(localStorage.getItem("data"))?.role;

  const navigate = useNavigate();

  useEffect(() => {
    if (searchTerm || selectedCompany !== "all") {
      setCurrentPage(0);
    }
  }, [searchTerm, selectedCompany]);

  useEffect(() => {
    if (searchTerm || selectedCompany !== "all") {
      searchData(currentPage);
    } else {
      getData(currentPage);
    }
  }, [searchTerm, selectedCompany, currentPage]);

  const searchData = async (pageNumber = 0) => {
    const token = JSON.parse(localStorage.getItem("data"))?.token;
    setLoader(true);

    try {
      const searchUrl = `/api/peme-appointment/seachPemeAppointmentsForLab`;
      const requestData = {
        labId: labId,
        companyId: selectedCompany === "all" ? null : selectedCompany,
        searchTerm,
      };
      const response = await axios.post(searchUrl, requestData, {
        params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` },
      });

      setAppointmentDetails(response.data.content || []);
      setCurrentPage(response.data.number || 0);
      setTotalPages(response.data.totalPages || 0);
    } catch (error) {
      handleError(error);
    } finally {
      setLoader(false);
    }
  };

  const getData = async (pageNumber = 0) => {
    setLoader(true);
    try {
      const token = JSON.parse(localStorage.getItem("data"))?.token;
      const trans = await axios.get(`/api/peme-appointment/getAllPemeAppointments/labId=${labId}`, {
        params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` },
      });

      setAppointmentDetails(trans.data.content || []);
      setCurrentPage(trans.data.number || 0);
      setTotalPages(trans.data.totalPages || 0);

      const response = await axios.get("/api/companydetails/getCompanies", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCompanies(response.data || []);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleCancelClick = (appointment) => {
    setSelectedAppointment(appointment);
    setIsCancelPopupOpen(true);
  };

  const handleCloseCancelPopup = () => {
    setIsCancelPopupOpen(false);
    getData();
  };

  const handleUploadReport = (appointmentId) => {
    setSelectedAppointmentId(appointmentId);
    setIsUploadModalOpen(true);
  };

  const handleCloseUploadModal = () => {
    setIsUploadModalOpen(false);
    getData();
  };

  const handleViewReport = (reportId) => {
    const token = JSON.parse(localStorage.getItem("data"))?.token;
    const url = `/api/peme-appointment-reports/view/${reportId}`;
    axios({
      url,
      method: "GET",
      responseType: "blob",
      headers: { Authorization: `Bearer ${token}` },
    }).then((response) => {
      const contentType = response.headers["content-type"] || "application/octet-stream";
      const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
      window.open(blobUrl, "_blank");
    }).catch(() => toast.error("Failed to view report."));
  };

  const handleDownloadReport = (reportId, fileName) => {
    const token = JSON.parse(localStorage.getItem("data"))?.token;
    axios({
      url: `/api/peme-appointment-reports/view/${reportId}`,
      method: "GET",
      responseType: "blob",
      headers: { Authorization: `Bearer ${token}` },
    }).then((response) => {
      const contentType = response.headers["content-type"] || "application/octet-stream";
      const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", fileName || "report");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    }).catch(() => toast.error("Failed to download report."));
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  const [isTestsModalOpen, setIsTestsModalOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);

  const openTestsModal = (pkg) => {
    setSelectedPackage(pkg);
    setIsTestsModalOpen(true);
  };

  const closeTestsModal = () => {
    setSelectedPackage(null);
    setIsTestsModalOpen(false);
  };

  const handleRescheduleAppointment = (appointmentId) => {
    setSelectedAppointmentId(appointmentId);
    setIsReschedulePopupOpen(true);
  };

  const handleCloseReschedulePopup = () => {
    setIsReschedulePopupOpen(false);
    getData();
  };

  const handleFetchReport = async (appointment) => {
    setLoader(true);
    const token = JSON.parse(localStorage.getItem('data'))?.token;

    try {
      await axios.post('/api/peme-appointment/fetchReport', appointment, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success('Report fetched successfully');
      getData();
    } catch (error) {
      handleError(error);
    } finally {
      setLoader(false);
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;
    let startPage = Math.max(0, currentPage - 2);
    let endPage = Math.min(totalPages - 1, currentPage + 2);

    if (currentPage <= 2) endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
    if (currentPage >= totalPages - 3) startPage = Math.max(0, totalPages - maxPageNumbersToShow);

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
          {i + 1}
        </Pagination.Item>
      );
    }
    return pageNumbers;
  };

  return (
    <div>
      {loader && <div className="loading"></div>}

      <div className="hm-card">
        {/* Header */}
        <div className="hm-card-header">
          <h3 className="hm-card-title">
            <i className="material-icons">local_hospital</i>
            PEME Appointment Details
          </h3>
          <span className="hm-badge hm-badge-primary">{appointmentDetails.length} Appointments</span>
        </div>

        {/* Filters */}
        <div className="hm-card-body border-bottom bg-light bg-opacity-50 p-3">
          <div className="row g-3">
            <div className="col-md-6 col-lg-4">
              <div className="position-relative">
                <input
                  type="search"
                  className="form-control ps-4"
                  placeholder="Search by Name or Phone number..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <i className="material-icons position-absolute text-muted" style={{ left: "10px", top: "50%", transform: "translateY(-50%)", fontSize: "1.1rem" }}>
                  search
                </i>
              </div>
            </div>

            {(userRole !== 'ROLE_LAB' && userRole !== 'ROLE_LAB_CORPORATE') && (
              <div className="col-md-6 col-lg-4">
                <select
                  id="companyFilter"
                  className="form-select"
                  value={selectedCompany || "all"}
                  onChange={(e) => setSelectedCompany(e.target.value)}
                >
                  <option value="all">ALL COMPANIES</option>
                  {companies.map((company) => (
                    <option key={company.id} value={company.id}>
                      {company.companyname}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>
        </div>

        {/* Table */}
        <div className="hm-card-body p-0">
          <div style={{ overflowX: "auto" }}>
            <table className="hm-table">
              <thead>
                <tr>
                  <th>Sl.No.</th>
                  <th>Patient Name</th>
                  <th>Phone Number</th>
                  <th>Date</th>
                  <th>Company</th>
                  <th>Package</th>
                  <th>Status</th>
                  <th>Reports</th>
                  <th>Order Status</th>
                </tr>
              </thead>
              <tbody>
                {appointmentDetails.length === 0 ? (
                  <tr>
                    <td colSpan="9">
                      <div className="hm-empty-state">
                        <i className="material-icons">event_busy</i>
                        <p>{loader ? "Loading PEME appointments..." : "No Data Available"}</p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  appointmentDetails.map((appointment, index) => (
                    <tr key={appointment.id}>
                      <td className="fw-semibold">{index + 1}</td>
                      <td>
                        <span
                          className="fw-semibold text-primary cursor-pointer"
                          style={{ cursor: "pointer" }}
                          title="Upload Report"
                          onClick={() => {
                            if (
                              appointment.appStatus?.appointmentStatus !== 'APPOINTMENT CANCELLED' &&
                              appointment.appStatus?.appointmentStatus !== 'APPOINTMENT COMPLETED'
                            ) {
                              handleUploadReport(appointment.id);
                            }
                          }}
                        >
                          {appointment.pemeDetails?.fullName || "—"}
                        </span>
                      </td>
                      <td className="small">{appointment.pemeDetails?.phoneNumber || "—"}</td>
                      <td className="small text-muted">{appointment.appointmentDate}</td>
                      <td className="fw-medium">{appointment.company?.companyname || "—"}</td>
                      <td>
                        {appointment.pack?.packagename && (
                          <div className="d-flex align-items-center gap-2">
                            <span className="hm-badge hm-badge-primary">{appointment.pack.packagename}</span>
                            <FiInfo
                              onClick={() => openTestsModal(appointment.packageid)}
                              className="text-primary cursor-pointer"
                              style={{ cursor: "pointer" }}
                              title="View Package Tests"
                            />
                          </div>
                        )}
                      </td>
                      <td>
                        <div className="d-flex flex-column gap-1">
                          <span className={
                            appointment.appStatus?.appointmentStatus?.includes("COMPLETED") || appointment.appStatus?.appointmentStatus?.includes("CONFIRMED") ? "hm-badge hm-badge-success" :
                            appointment.appStatus?.appointmentStatus?.includes("CANCELLED") ? "hm-badge hm-badge-danger" :
                            "hm-badge hm-badge-warning"
                          }>
                            {appointment.appStatus?.appointmentStatus || "—"}
                          </span>
                          {(appointment.appStatus?.appointmentStatus !== 'APPOINTMENT CANCELLED') && (appointment.appStatus?.appointmentStatus !== 'APPOINTMENT COMPLETED') && (
                            <div className="d-flex gap-1 mt-1">
                              <button
                                className="btn btn-outline-danger btn-sm rounded-pill px-2 py-0 extra-small"
                                onClick={() => handleCancelClick(appointment)}
                              >
                                Cancel
                              </button>
                              <button
                                className="btn btn-outline-warning btn-sm rounded-pill px-2 py-0 extra-small"
                                onClick={() => handleRescheduleAppointment(appointment.id)}
                              >
                                Reschedule
                              </button>
                            </div>
                          )}
                        </div>
                      </td>
                      <td>
                        {appointment.orderStatus ? (
                          appointment.orderStatus?.appointmentReport ? (
                            appointment.reportstatus === 'APPROVED' ? (
                              <a
                                href={appointment.orderStatus.appointmentReport}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-primary btn-sm rounded-pill px-2 py-0 extra-small"
                              >
                                View Report
                              </a>
                            ) : (
                              <span className="hm-badge hm-badge-warning extra-small">PENDING APPROVAL</span>
                            )
                          ) : (
                            <button
                              className="btn btn-outline-primary btn-sm rounded-pill px-2 py-0 extra-small"
                              onClick={() => handleFetchReport(appointment)}
                            >
                              Fetch Report
                            </button>
                          )
                        ) : (
                          appointment.reportstatus ? (
                            appointment.reportstatus === 'APPROVED' ? (
                              <div>
                                {(appointment.reports || []).length > 0 ? (
                                  <ul className="list-unstyled mb-0">
                                    {(appointment.reports || []).map((report, ri) => (
                                      <li key={report.id} className="d-flex align-items-center gap-1 mb-1">
                                        <span
                                          className="text-primary text-truncate cursor-pointer small"
                                          onClick={() => handleViewReport(report.id)}
                                          title={report.fileName || `File ${ri + 1}`}
                                        >
                                          {report.fileName || `File ${ri + 1}`}
                                        </span>
                                        <FaDownload
                                          size={12}
                                          className="text-success cursor-pointer"
                                          title="Download"
                                          onClick={() => handleDownloadReport(report.id, report.fileName)}
                                        />
                                      </li>
                                    ))}
                                  </ul>
                                ) : (
                                  <span className="text-muted extra-small">No files</span>
                                )}

                                {(userRole === "ROLE_ADMIN" || userRole === "ROLE_SUPER") && (
                                  <FaEdit
                                    className="text-secondary cursor-pointer mt-1"
                                    size={14}
                                    onClick={() => handleUploadReport(appointment.id)}
                                    title="Modify Report"
                                  />
                                )}
                              </div>
                            ) : (
                              <span className="hm-badge hm-badge-warning extra-small">PENDING APPROVAL</span>
                            )
                          ) : (
                            <span className="text-muted extra-small">No Report</span>
                          )
                        )}
                      </td>
                      <td>
                        <div className="small fw-semibold">{appointment.orderStatus?.status || "—"}</div>
                        {appointment.orderStatus?.orderId && (
                          <code className="extra-small">{appointment.orderStatus.orderId}</code>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="d-flex justify-content-center py-3">
              <Pagination className="hm-pagination">
                <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
                <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
                {renderPageNumbers()}
                <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage >= totalPages - 1} />
                <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage >= totalPages - 1} />
              </Pagination>
            </div>
          )}
        </div>
      </div>

      {isTestsModalOpen && (
        <TestForPackage
          isOpen={isTestsModalOpen}
          onRequestClose={closeTestsModal}
          packageId={selectedPackage}
        />
      )}

      {isReschedulePopupOpen && (
        <PemeAppointmentReschedule
          isOpen={isReschedulePopupOpen}
          onRequestClose={handleCloseReschedulePopup}
          appointmentId={selectedAppointmentId}
        />
      )}

      {isCancelPopupOpen && (
        <PemeAppointmentCancel
          isOpen={isCancelPopupOpen}
          onRequestClose={handleCloseCancelPopup}
          appointment={selectedAppointment}
        />
      )}

      {isUploadModalOpen && (
        <UploadPemeReport
          isOpen={isUploadModalOpen}
          onRequestClose={handleCloseUploadModal}
          pemeAppointmentId={selectedAppointmentId}
        />
      )}
    </div>
  );
}

export default ViewPemeAppointmentsForLab;

